import { useTranslation } from 'react-i18next';

export type StatusMessage = { text: string; error: boolean };

type ManageDangerZoneProps = {
  unpaired: boolean;
  hasDevice: boolean;
  disconnectPending: boolean;
  deletePending: boolean;
  dangerStatus: StatusMessage | null;
  onDisconnect: () => void;
  onDelete: () => void;
};

/** Settings-tab disconnect / delete actions for a display. */
export function ManageDangerZone({
  unpaired,
  hasDevice,
  disconnectPending,
  deletePending,
  dangerStatus,
  onDisconnect,
  onDelete,
}: ManageDangerZoneProps) {
  const { t } = useTranslation('displays');
  return (
    <section className="space-y-3 border-t border-line pt-5">
      <h3 className="m-0 text-sm font-bold text-ink">{t('manage.danger.heading')}</h3>
      <p className="m-0 text-sm text-muted">{t('manage.danger.body')}</p>
      <div className="flex flex-wrap gap-2.5">
        <button
          type="button"
          disabled={unpaired || !hasDevice || disconnectPending || deletePending}
          onClick={onDisconnect}
          className="rounded-[10px] border border-line px-4 py-2.5 text-sm font-semibold text-ink hover:border-[var(--gs-accent)] disabled:opacity-50"
        >
          {disconnectPending ? t('manage.danger.disconnecting') : t('manage.danger.disconnectPlayer')}
        </button>
        <button
          type="button"
          disabled={deletePending || disconnectPending}
          onClick={onDelete}
          className="rounded-[10px] border px-4 py-2.5 text-sm font-bold disabled:opacity-50"
          style={{ borderColor: 'var(--gs-bad)', color: 'var(--gs-bad)' }}
        >
          {deletePending ? t('manage.danger.deleting') : t('manage.danger.deleteDisplay')}
        </button>
      </div>
      {dangerStatus ? (
        <p
          className="m-0 text-sm font-medium"
          style={{ color: dangerStatus.error ? 'var(--gs-bad)' : 'var(--gs-ok)' }}
          role="status"
        >
          {dangerStatus.text}
        </p>
      ) : null}
    </section>
  );
}
